'use strict'

module.exports = {
  copySync: require('./copy-sync')
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-artifactor/~/fs-extra/lib/copy-sync/index.js
// module id = 2026
// module chunks = 0 1